module.exports = __webpack_public_path__ + "img/3.203e9e1b.png";